import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";

const nonBreakingSpace = "\u00A0";

const Header: React.FC<{
  icon: React.ReactNode;
  onIconClick?: React.ReactEventHandler<HTMLAnchorElement>;
  title?: string;
}> = ({ icon, onIconClick, title }) => (
  <header sx={{ position: "relative" }}>
    <a sx={iconStyle} onClick={onIconClick} data-name="header:icon">
      {icon}
    </a>
    <div
      sx={{
        flexGrow: 1,
        textAlign: "center",
        color: "dt_content_primary",
        fontSize: "22px",
        lineHeight: "42px",
        fontWeight: 800,
      }}
    >
      {title || nonBreakingSpace}
    </div>
  </header>
);

export default Header;

const iconStyle: ThemeUIStyleObject = {
  position: "absolute",
  display: "inline-block",
  fontSize: "24px",
  padding: RAW_cssValue("10px 10px"),
  cursor: "pointer",
};
